import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const token = localStorage.getItem("token");
// const userInfo = JSON.parse(localStorage.getItem("userInfo"));

//function for get all tags
export const getAllTags = async (query = "") => {
  try {
    let requestUrl =
      url.API_BASE_URL +
      url.API_GET_ALL_TAGS +
      `?token=${token}&filterlabelname=${query}`;

    const response = await getData(requestUrl);

    // console.log("response allTags", response);

    if (response.status) {
      const tagsData = response.data.map((tag) => ({
        value: tag.value,
        label: tag.label,
      }));

      // setAllTags(tagsData);
      return tagsData;
    }
  } catch (error) {
    console.log(error.message);
    return [];
  }
};

export const removeTagHandler = async (
  tagIds,
  componentId,
  componentUrl = ""
) => {
  try {
    let tagRequestUrl =
      url.API_BASE_URL +
      componentUrl +
      `/${componentId}` +
      `?token=${token}` +
      `&action=${"0"}`;

    const response = await putData(tagRequestUrl, tagIds);

    console.log("response in remove tag ------->", response);

    if (response.status) {
      return [response.data];
    } else {
      return [];
    }
  } catch (error) {
    console.log(error.message);
    return [];
  }
};
